import { render, staticRenderFns } from "./OrgVehicleList.vue?vue&type=template&id=82f7388c"
import script from "./OrgVehicleList.vue?vue&type=script&lang=js"
export * from "./OrgVehicleList.vue?vue&type=script&lang=js"
import style0 from "./OrgVehicleList.vue?vue&type=style&index=0&id=82f7388c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports